import type { PriceInfo } from "epsm-api-types/ws";

export const mergeSortedResponses = (
	...responses: PriceInfo[][]
): PriceInfo[] => {
	const mergedResponse: PriceInfo[] = [];
	const indices = new Array(responses.length).fill(0);

	while (true) {
		let minTime = Number.POSITIVE_INFINITY;
		let indexesOfValuesWithMinTime: number[] = [];

		for (let i = 0; i < responses.length; i++) {
			const idx = indices[i];
			if (idx < responses[i].length) {
				const time = responses[i][idx].time;
				if (time < minTime) {
					minTime = time;
					indexesOfValuesWithMinTime = [i];
				} else if (time === minTime) {
					indexesOfValuesWithMinTime.push(i);
				}
			}
		}

		if (indexesOfValuesWithMinTime.length === 0) {
			break;
		}

		const mergedItem: Partial<PriceInfo> = {};
		for (const srcIndex of indexesOfValuesWithMinTime) {
			Object.assign(mergedItem, responses[srcIndex][indices[srcIndex]]);
			indices[srcIndex]++;
		}
		mergedResponse.push(mergedItem as PriceInfo);
	}

	return mergedResponse;
};
